/**
 * Selects text when input element is clicked
 */
angular.module('coreModule').directive('swSelectOnClick', () => ({
  restrict: 'A',

  link: function (scope, element) {
    element.on('click', function () {
      this.select();
    });

    scope.$on('$destroy', () => {
      element.unbind('scope');
    });
  },
}));
